import { getUserProfile } from "helpers";
import { useAuth0 } from "@auth0/auth0-react";
import { useState } from "react";
import { getExpireDate } from "helpers";

export const useSaveButton = () => {
  const { loginWithRedirect } = useAuth0();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenModalLoginToSave, setIsOpenModalLoginToSave] = useState(false);

  const handleRedirectColection = async () => {
    const userProfile = getUserProfile();
    if (!userProfile?.id) {
      setIsOpenModalLoginToSave(true)
      return;
    }
    window.location.href = "/recetas/colecciones";
    /* if(userProfile?.subscriptionStatus === "subscribed") {
      window.location.href = "/recetas/colecciones";
      return;
    }
    const hasCollection = await hasColection(userProfile.id);
    if (!hasCollection) {
      setIsOpenModal(true);     
    } else {
      window.location.href = "/recetas/colecciones";
    } */
  }

  const redirectLogin = async () => {
    let expDate = getExpireDate(1);
    document.cookie = `auth0_redir=${
      window.location.href
    };expires=${expDate.toUTCString()};path=/`;
    loginWithRedirect();
  };

  const hasColection = async (userId) => {
    try {
      const fetchRecipeCollection = await fetch(`/api/user-data/${encodeURIComponent(userId)}`, {
        method: "POST"
      });
      const dataRecipeCollection = await fetchRecipeCollection.json();
      const recipeData = dataRecipeCollection?.user?.data?.types?.recipe || {};
      const total = Object.values(recipeData).reduce((acc, arr) => acc + arr.length, 0);
      return total > 0;
    } catch (error) {
      return false;
    }
  }

  return {
    handleRedirectColection,
    isOpenModal,
    setIsOpenModal,
    isOpenModalLoginToSave,
    setIsOpenModalLoginToSave,
    redirectLogin
  };
}